import styled from 'styled-components';
import Calendar from 'react-calendar';
import { Calendar as CalendarIcon } from 'react-feather';

export const FormDate = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StyledDateField = styled.div`
  position: relative;
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  & input:hover {
    cursor: pointer;
  }
`;

export const StyledCalendar = styled(Calendar)`
  &.react-calendar {
    position: absolute;
    top: 100%;
    left: 0;
    width: 300px;
    margin-top: 4px;
    z-index: 1000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
  }

  .react-calendar__tile-away-dates {
    background-color: rgba(0, 110, 220, 0.5);
  }
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  margin-right: 5px;
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;
